// src/config.js
const getUrls = () => {
    const hostname = window.location.hostname;
    
    // For local development (localhost, 127.0.0.1, or local network IPs)
    if (
        hostname === "localhost" || 
        hostname === "127.0.0.1" || 
        hostname.startsWith("192.168.") || 
        hostname.startsWith("10.") || 
        hostname.startsWith("172.16.") || 
        hostname.startsWith("172.31.")
    ) {
        return {
            BASE_URL: `http://${hostname}:5000/`,
            SOCKET_URL: `http://${hostname}:5000`
        };
    }
    
    // For production
    return {
        BASE_URL: "https://zippygo.cscodetech.cloud/",
        SOCKET_URL: "https://zippygo.cscodetech.cloud"
    };
};

const urls = getUrls();
export const BASE_URL = urls.BASE_URL;
export const SOCKET_URL = urls.SOCKET_URL;
